<div class="dashboard-content">
    <div class="dashboard-tiles">
        <div class="dashboard-tile" [ngClass]="{'good': unmanagedAlerts?.length === 0, 'bad': (unmanagedAlerts?.length ?? 0) > 0, 'coloured': unmanagedAlerts !== undefined}">
            <span class="dbt-title">Unmanaged alerts</span>
            <span class="dbt-data">{{unmanagedAlerts?.length ?? '-'}}</span>
            <span class="dbt-actions"><button (click)="navigateToAlerts()" class="button wide outline bw">Go to Alerts</button></span>
        </div>
        <div class="dashboard-tile wide">
            <span class="dbt-title mb-2 mt-4">Alert detections this year</span>
            <div class="dbt-chart">
                <div id="alertDetectionsChart" #alertDetectionsChart></div>
            </div>
        </div>
        <div class="dashboard-tile wide">
            <span class="dbt-title mb-2 mt-4">Alert detections in {{lastYear}}</span>
            <div class="dbt-chart">
                <div id="alertDetectionsLastChart" #alertDetectionsLastChart></div>
            </div>
        </div>
    </div>
    <div class="dashboard-tiles">
        <div class="dashboard-tile" [ngClass]="{'good': (totalNodes ?? 0) > 0, 'coloured': totalNodes !== undefined}">
            <span class="dbt-title">Registered nodes</span>
            <span class="dbt-data">{{totalNodes ?? '-'}}</span>
            <span class="dbt-actions"></span>
        </div>
        <div class="dashboard-tile" [ngClass]="{'good': (workingNodes ?? 0) > 0, 'bad': workingNodes === 0, 'coloured': workingNodes !== undefined}">
            <span class="dbt-title">Working nodes</span>
            <span class="dbt-data">{{workingNodes ?? '-'}}</span>
            <span class="dbt-actions"><button (click)="navigateToNodeManager()" class="button wide outline bw">Node Manager</button></span>
        </div>
        <div class="dashboard-tile" [ngClass]="{'good': (validatedNodes ?? 0) > 0, 'bad': validatedNodes === 0, 'coloured': validatedNodes !== undefined}">
            <span class="dbt-title">Validated nodes</span>
            <span class="dbt-data">{{validatedNodes ?? '-'}}</span>
            <span class="dbt-actions"><button (click)="navigateToNodeManager()" class="button wide outline bw">Node Manager</button></span>
        </div>
        <div class="dashboard-tile">
            <span class="dbt-title">Backups</span>
            <span class="dbt-data">{{runningBackupSchedules ?? '-'}}</span>
            <span class="dbt-actions">Running schedules</span>
        </div>
    </div>
</div>